import * as React from "react";

import {FBDividerOptions} from "./FBDivider.Options";

import {GetModel} from "FormBuilder/Events/GetModel";
import {FieldTypeEnum} from "FormBuilder/Fields/Core/FBFieldBase.options";
import {GetFieldOptions} from "FormBuilder/Events/GetFieldOptions";
import {GetField} from "FormBuilder/Events/GetField";
import {FBFieldBase, FBFieldBaseProps, FBFieldBaseState} from "FormBuilder/Fields/Core/FBFieldBase";
import {FBDividerModel} from "./FBDivider.Model";
import {EventManager} from "shared/core/Events/EventManager";

export class FBDivider extends FBFieldBase<FBParagraphProps,{}>{

    static defaultProps: Partial<FBParagraphProps> = {

    };

    constructor(props: FBParagraphProps) {
        super(props);
        this.state = {

        };
    }


    SubRender() {
        return (
            <div className={'rnParagraphField'} style={{padding:'10 0'}}>
                {this.Model.Options.Title.trim()!=''&&<h3 style={{margin:0}}>{this.Model.Options.Title}</h3>}
                <hr style={{marginTop:this.Model.Options.Title.trim()!=''?0:undefined, width:'100%',borderStyle:this.Model.Options.Style,borderColor:this.Model.Options.Color,background:'none',borderWidth:1}}/>
            </div>
        );


    }

    protected InternalSerialize(obj: object) {
        return null;
    }

    GetStoresInformation(): boolean {
        return false;
    }




}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface FBParagraphProps extends FBFieldBaseProps{
    Model:FBDividerModel;

}

interface FBDropDownState extends FBFieldBaseState{

}



EventManager.Subscribe(GetModel,(event)=>{
    if(event.Options.Type==FieldTypeEnum.Divider)
        return new FBDividerModel(event.Options as FBDividerOptions,event.parent).Initialize(event.PreviousData);
});


EventManager.Subscribe(GetFieldOptions,(event)=>{
    if(event.Type==FieldTypeEnum.Divider)
        return new FBDividerOptions();
});

EventManager.Subscribe(GetField,(event)=>{
    if(event.Model.Options.Type==FieldTypeEnum.Divider)
        return <FBDivider Model={event.Model as FBDividerModel} />
});

//#endregion "My Region"